"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _WidgetBase = _interopRequireDefault(require("../Widget/WidgetBase"));

var _ = require("../");

var _styles = require("@material-ui/core/styles");

var _OwnerIcon = _interopRequireDefault(require("./OwnerIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative"
  },
  header: {
    backgroundColor: "#ccc",
    backgroundImage: props => {
      return "url(" + props.imageUrl + ")";
    },
    backgroundSize: "cover",
    width: "100%",
    height: theme.spacing(30)
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  icon: {
    fontSize: theme.spacing(8),
    margin: theme.spacing(2)
  },
  title: {
    fontSize: "18px",
    lineHeight: "20px",
    fontWeight: "normal",
    color: "white"
  },
  body: {
    position: "absolute",
    top: theme.spacing(30),
    right: 0,
    bottom: 0,
    left: 0
  },
  grid: {
    width: "270px",
    margin: "auto"
  }
}));

const OwnerWidget = (_ref) => {
  let _ref$owner = _ref.owner,
      owner = _ref$owner === void 0 ? {} : _ref$owner,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "list" : _ref$layout,
      onSelect = _ref.onSelect,
      props = _objectWithoutPropertiesLoose(_ref, ["owner", "layout", "onSelect"]);

  const _useState = (0, _react.useState)(false),
        overflow = _useState[0],
        setOverflow = _useState[1];

  const bodyRef = (0, _react.useRef)();
  const imageUrl = owner.imageUrl || props.imageUrl;
  const abbr = owner.abbr || props.abbr;
  const title = owner.title || props.title || "N/A";
  const apps = owner.apps || props.apps;
  const theme = owner.theme || props.theme;
  const classes = useStyles({
    imageUrl
  });
  (0, _react.useEffect)(() => {
    const height = bodyRef.current && bodyRef.current.offsetHeight;
    const width = bodyRef.current && bodyRef.current.offsetWidth;
    const itemsHeight = apps && apps.length * 57;

    if (layout === "grid" && apps.length > 6) {
      setOverflow(true);
    }

    if (layout === "list" && itemsHeight > height) {
      setOverflow(true);
    }
  });
  return _react.default.createElement(_WidgetBase.default, _extends({}, props, {
    classes: classes
  }), _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_OwnerIcon.default, {
    theme: theme,
    title: title,
    abbr: abbr,
    className: classes.icon
  }), _react.default.createElement(_Typography.default, {
    className: classes.title
  }, title))), _react.default.createElement("div", {
    className: classes.body,
    ref: bodyRef
  }, overflow && _react.default.createElement(_.FilterAppsControlled, {
    apps: apps,
    layout: layout,
    onSelect: onSelect
  }), !overflow && layout === "grid" && _react.default.createElement(_.AppsGrid, {
    className: classes.grid,
    apps: apps,
    onSelect: onSelect
  }), !overflow && layout === "list" && _react.default.createElement(_.AppsList, {
    apps: apps,
    onSelect: onSelect
  })));
};

OwnerWidget.defaultProps = {
  type: "owner",
  size: "4:6",
  layout: "list"
};
var _default = OwnerWidget;
exports.default = _default;
module.exports = exports.default;